import { OnboardingType } from 'models/lead.model'
import type { TPlansDecorations } from 'models/plan-decoration.model'

export const PLANS_DECORATIONS_INTL_MW: TPlansDecorations = {
  USD: {
    [OnboardingType.PURCHASE]: [
      {
        name: 'plan1',
        decoratedPrice: '$6.99',
        decoratedStrikethroughPrice: '$13.99',
        decoratedPricePerDay: '$0.99',
        title: '1-week trial',
        totalPriceText: '$6.99',
        trialBadgeText: '4-week plan',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '1-week',
        discountBadgeText: '50%',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 6.99,
        analyticsProductName: 'intellio_USD_1_mo_39.99_intro_7_days_6.99',
        productPrice: '6.99+39.99',
      },
      {
        name: 'plan2',
        isDefault: true,
        decoratedPrice: '$19.99',
        decoratedStrikethroughPrice: '$39.99',
        decoratedPricePerDay: '$0.66',
        title: '4-week plan',
        totalPriceText: '$19.99',
        trialBadgeText: '',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        discountBadgeText: '50%',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 19.99,
        analyticsProductName: 'intellio_USD_1_mo_39.99_intro_1_mo_19.99',
        productPrice: '19.99+39.99',
      },
      {
        name: 'plan3',
        decoratedPrice: '$39.99',
        decoratedStrikethroughPrice: '$79.99',
        decoratedPricePerDay: '$0.44',
        title: '12-week plan',
        totalPriceText: '$39.99',
        trialBadgeText: '',
        subscriptionPriceText: '$79.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        discountBadgeText: '50%',
        analyticsPrice: 79.99,
        analyticsTrialPrice: 39.99,
        analyticsProductName: 'intellio_USD_3_mo_79.99_intro_3_mo_39.99',
        productPrice: '39.99+79.99',
      },
    ],
    [OnboardingType.CANCEL_OFFER]: [
      {
        name: 'plan1',
        decoratedPrice: '$4.89',
        decoratedStrikethroughPrice: '$13.99',
        decoratedPricePerDay: '$0.69',
        title: '1-week trial',
        totalPriceText: '$4.89',
        trialBadgeText: '4-week plan',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '1-week',
        discountBadgeText: '65%',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 4.89,
        analyticsProductName: 'intellio_USD_1_mo_39.99_intro_7_days_4.89',
        productPrice: '4.89+39.99',
      },
      {
        name: 'plan2',
        isDefault: true,
        decoratedPrice: '$13.99',
        decoratedStrikethroughPrice: '$39.99',
        decoratedPricePerDay: '$0.46',
        title: '4-week plan',
        totalPriceText: '$13.99',
        trialBadgeText: '',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        discountBadgeText: '65%',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 13.99,
        analyticsProductName: 'intellio_USD_1_mo_39.99_intro_1_mo_13.99',
        productPrice: '13.99+39.99',
      },
      {
        name: 'plan3',
        decoratedPrice: '$27.99',
        decoratedStrikethroughPrice: '$79.99',
        decoratedPricePerDay: '$0.31',
        title: '12-week plan',
        totalPriceText: '$27.99',
        trialBadgeText: '',
        subscriptionPriceText: '$79.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        discountBadgeText: '65%',
        analyticsPrice: 79.99,
        analyticsTrialPrice: 27.99,
        analyticsProductName: 'intellio_USD_3_mo_79.99_intro_3_mo_27.99',
        productPrice: '27.99+79.99',
      },
    ],
  },
}
